<template></template>
<script>

export default {
        name: "Token",
        methods: {
            osvezavanjeTokena(token) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        this.$http
                    .get("https://79.175.74.50:1902/token/refresh?refresh_token=" + localStorage.getItem('user-refresh-token'))
                    .then(response => {
                        if (response.status === 200) {
                        localStorage.setItem('user-token', response.data.access_token);
                        localStorage.setItem('user-refresh-token', response.data.refresh_token);

                        resolve(response.data.access_token);
              }
                    })
                    .catch(e => {
                        // console.log("osvezavanjeTokena .catch - " + e);

              if (e.response.status === 401)
                alert("Neuspesno osvezavanje tokena");
              else 
                alert("Osvezavanje tokena - " + e.response.data.message)
              

              reject(new Error("…"));
                    });
                    }, 200);    
                })
            }
        }
}
</script>